import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Api_Token } from "../../../env"; // axios instance with token
import { useAlertContext } from "../../../service/AlertServices";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { ConfirmDeletePopup } from "../../../composant/Popup/confirmDelete";

export default function PageProduits() {
  return <Indexdasbord Children={<ProduitsManagement />} />;
}

function ProduitsManagement() {
  const [produits, setProduits] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    NomProduit: "",
    url_Image: null,
    ImageUpload: null,
    PanierImage: null,
    text: false,
    removeBg: false,
    prix: 0,
    type: "simple",
    cadrage: null,
    displayToclient: false,
    descriptif: "",
    titreseo: "",
    promo: 0,
    dementionDesc: "",
    promoCount: false,
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [errors, setErrors] = useState({});
  const { showAlert } = useAlertContext();
  const [PopupConfirmDelete, setPopupConfirmDelete] = useState(false);
  const [idDelete, setIdDelete] = useState(false);

  const fetchProduits = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Api_Token.get(
        `produit/getAll?page=${page + 1}&limit=${rowsPerPage}`
      );
      setProduits(res.data.produits || []);
      setTotal(res.data.total || 0);
    } catch {
      showAlert("Erreur chargement produits", "error");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, showAlert]);

  useEffect(() => {
    fetchProduits();
  }, [fetchProduits]);
  const handleEdit = (produit) => {
    setFormData({
      id: produit.id ?? null,
      NomProduit: produit.NomProduit || "",
      url_Image: produit.url_Image || null,
      ImageUpload: produit.ImageUpload || null,
      PanierImage: produit.PanierImage || null,
      text: produit.text || false,
      removeBg: produit.removeBg ?? false,
      prix: produit.prix ?? 0,
      type: produit.type || "simple",
      cadrage: produit.cadrage || null,
      displayToclient: produit.displayToclient ?? false,
      descriptif: produit.descriptif || "",
      titreseo: produit.titreseo || "",
      promo: produit.promo ?? 0,
      dementionDesc: produit.dementionDesc || "",
      promoCount: produit.promoCount ?? false,
    });
    setErrors({});
    setOpenForm(true);
  };

  const handleDelete = async (id) => {
    try {
      await Api_Token.delete(`produit/delete/${id}`);
      showAlert("Produit supprimé", "success");
      fetchProduits();
    } catch {
      showAlert("Erreur suppression", "error");
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.NomProduit || formData.NomProduit.trim() === "") {
      newErrors.NomProduit = "Le nom est requis";
    }
    if (!formData.prix || formData.prix < 0) {
      newErrors.prix = "Le prix est requis et doit être >= 0";
    }
    return newErrors;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      if (formData.id) {
        await Api_Token.put(`produit/update/${formData.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        showAlert("Produit modifié", "success");
      } else {
        await Api_Token.post("produit/create/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        showAlert("Produit ajouté", "success");
      }
      setOpenForm(false);
      fetchProduits();
    } catch {
      showAlert("Erreur formulaire", "error");
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Gestion des produits
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          setFormData({
            id: null,
            NomProduit: "",
            url_Image: null,
            ImageUpload: null,
            PanierImage: null,
            text: false,
            removeBg: false,
            prix: 0,
            type: "simple",
            cadrage: null,
            displayToclient: false,
            descriptif: "",
            titreseo: "",
            promo: 0,
            dementionDesc: "",
            promoCount: false,
          });
          setOpenForm(true);
        }}
        sx={{ mb: 2 }}
      >
        Ajouter produit
      </Button>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Prix</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Afficher au client</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {produits.map((produit) => (
              <TableRow key={produit.id}>
                <TableCell>{produit?.NomProduit}</TableCell>
                <TableCell>
                  <img
                    src={produit.url_Image}
                    alt={produit.NomProduit}
                    style={{
                      width: "80px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                </TableCell>
                <TableCell>{produit.prix} MAD</TableCell>
                <TableCell>{produit.type}</TableCell>
                <TableCell>{produit.displayToclient ? "Oui" : "Non"}</TableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => handleEdit(produit)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      setIdDelete(produit.id);
                      setPopupConfirmDelete(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
        />
      </Paper>

      <ProduitForm
        formData={formData}
        setFormData={setFormData}
        openForm={openForm}
        setOpenForm={setOpenForm}
        handleFormSubmit={handleFormSubmit}
        errors={errors}
        setErrors={setErrors}
      />
      <BackLoadingSimple open={loading} />
      <ConfirmDeletePopup
        open={PopupConfirmDelete}
        onClose={() => setPopupConfirmDelete(false)}
        confirm={() => {
          handleDelete(idDelete);
          setPopupConfirmDelete(false);
        }}
      />
    </Box>
  );
}

function ProduitForm({
  formData,
  setFormData,
  openForm,
  setOpenForm,
  handleFormSubmit,
  errors,
  setErrors,
}) {
  console.log("formData :", formData);
  // handle file change
  const handleFileChange = (file, field) => {
    if (file) {
      setFormData({ ...formData, [field]: file });
    }
  };

  const handleRemoveFile = (field) => {
    setFormData({ ...formData, [field]: null });
  };

  // Validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.NomProduit || formData.NomProduit.trim() === "") {
      newErrors.NomProduit = "Le nom du produit est obligatoire.";
    }

    if (!formData.url_Image)
      newErrors.url_Image = "L'image du produit est obligatoire.";
    if (!formData.ImageUpload)
      newErrors.ImageUpload = "L'image upload est obligatoire.";
    if (!formData.PanierImage)
      newErrors.PanierImage = "L'image panier est obligatoire.";

    if (!formData.prix || formData.prix <= 0)
      newErrors.prix = "Le prix est obligatoire et doit être supérieur à 0.";

    // Options validation
    if (!formData.cadrage) newErrors.cadrage = "Le cadrage est obligatoire.";
    if (!formData.type) newErrors.type = "Le type est obligatoire.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle submit
  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleFormSubmit(e, formData);
    }
  };

  return (
    <Dialog
      open={openForm}
      onClose={() => setOpenForm(false)}
      fullWidth
      maxWidth="md"
    >
      <form onSubmit={onSubmit} noValidate>
        <DialogTitle>
          {formData.id ? "Modifier" : "Ajouter"} produit
        </DialogTitle>
        <DialogContent>
          <Typography>information Produits :</Typography>
          <TextField
            margin="dense"
            label="Nom"
            fullWidth
            required
            value={formData?.NomProduit || ""}
            onChange={(e) =>
              setFormData({ ...formData, NomProduit: e.target.value })
            }
            error={!!errors?.NomProduit}
            helperText={errors?.NomProduit}
          />
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            multiline
            rows={3}
            value={formData?.descriptif || ""}
            onChange={(e) =>
              setFormData({ ...formData, descriptif: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Titre SEO"
            fullWidth
            value={formData?.titreseo || ""}
            onChange={(e) =>
              setFormData({ ...formData, titreseo: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Promo"
            type="number"
            fullWidth
            value={formData?.promo || ""}
            onChange={(e) =>
              setFormData({ ...formData, promo: parseFloat(e.target.value) })
            }
          />
          <TextField
            margin="dense"
            label="Description Dimensions"
            fullWidth
            value={formData?.dementionDesc || ""}
            onChange={(e) =>
              setFormData({ ...formData, dementionDesc: e.target.value })
            }
          />
          {/* Images */}

          <TextField
            margin="dense"
            label="Prix"
            type="number"
            fullWidth
            required
            value={formData?.prix || ""}
            onChange={(e) =>
              setFormData({ ...formData, prix: parseFloat(e.target.value) })
            }
            error={!!errors?.prix}
            helperText={errors?.prix}
          />
          <Divider sx={{ marginTop: "5%" }} />
          <Typography>option Produits :</Typography>
          {/* Cadrage */}
          <FormControl
            required
            fullWidth
            margin="dense"
            error={!!errors?.cadrage}
          >
            <InputLabel id="cadrage-label">Cadrage</InputLabel>
            <Select
              labelId="cadrage-label"
              value={formData?.cadrage || ""}
              onChange={(e) =>
                setFormData({ ...formData, cadrage: e.target.value })
              }
            >
              {["1/1", "2/3", "3/4", "4/3", "16/9", "9/16"].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {errors.cadrage && (
              <p style={{ color: "red", fontSize: "0.8rem" }}>
                {errors.cadrage}
              </p>
            )}
          </FormControl>

          {/* Type */}
          <FormControl required fullWidth margin="dense" error={!!errors?.type}>
            <InputLabel id="type-label">Type</InputLabel>
            <Select
              labelId="type-label"
              value={formData?.type || "simple"}
              onChange={(e) =>
                setFormData({ ...formData, type: e.target.value })
              }
            >
              <MenuItem value="simple">Simple</MenuItem>
              <MenuItem value="identite">Identité</MenuItem>
              <MenuItem value="multiple">multiple</MenuItem>
            </Select>
            {errors.type && (
              <p style={{ color: "red", fontSize: "0.8rem" }}>{errors.type}</p>
            )}
          </FormControl>

          {/* Options toggles */}
          {["displayToclient", "text", "removeBg", "promoCount"].map(
            (field) => (
              <FormControl fullWidth margin="dense" key={field}>
                <InputLabel id={`${field}-label`}>{field}</InputLabel>
                <Select
                  labelId={`${field}-label`}
                  value={formData[field]}
                  onChange={(e) =>
                    setFormData({ ...formData, [field]: e.target.value })
                  }
                >
                  <MenuItem value={true}>Oui</MenuItem>
                  <MenuItem value={false}>Non</MenuItem>
                </Select>
              </FormControl>
            )
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {["url_Image", "ImageUpload", "PanierImage"].map((field) => (
              <div key={field}>
                <FileInput
                  label={
                    field === "url_Image"
                      ? "Image produit"
                      : field === "ImageUpload"
                      ? "Image Upload"
                      : "Panier Image"
                  }
                  value={formData[field]}
                  onChange={(file) => handleFileChange(file, field)}
                  onRemove={() => handleRemoveFile(field)}
                />
                {errors[field] && (
                  <p style={{ color: "red", fontSize: "0.8rem" }}>
                    {errors[field]}
                  </p>
                )}
              </div>
            ))}{" "}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenForm(false)}>Annuler</Button>
          <Button type="submit" color="primary">
            {formData.id ? "Modifier" : "Ajouter"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

const FileInput = ({ label, value, onChange, onRemove }) => {
  const [preview, setPreview] = useState(null);

  // إذا كان عندي value من السيرفر (URL)، نعرضها
  useEffect(() => {
    if (value && typeof value === "string") {
      setPreview(value);
    } else if (value instanceof File) {
      setPreview(URL.createObjectURL(value));
    } else {
      setPreview(null);
    }
  }, [value]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      onChange(file); // نمرر الملف للأب
    }
  };

  const handleRemove = () => {
    setPreview(null);
    onRemove();
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      <label>{label}</label>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        {/* Preview */}
        {preview && (
          <div style={{ position: "relative" }}>
            <img
              src={preview}
              alt="preview"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
            <IconButton
              onClick={handleRemove}
              size="small"
              style={{
                position: "absolute",
                top: -10,
                right: -10,
                background: "white",
                color: "red",
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        )}

        {/* Hidden file input */}
        <input
          type="file"
          accept="image/*"
          id={`file-input-${label}`}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <label htmlFor={`file-input-${label}`}>
          <Button variant="contained" component="span">
            Upload
          </Button>
        </label>
      </div>
    </div>
  );
};
